import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/base.css";
import "./styles/studio.css";
import "./styles/hifi.css";
import "./styles/zoo.css";
import "./styles/eigenbloom.css";
import "./styles/river.css";
import "./styles/editor.css";
import "./styles/legal.css";
import "./styles/tour.css";

document.documentElement.dataset.skin = "studio";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
